export const userAgent: string =
  window?.navigator?.userAgent?.toLocaleLowerCase();
